const layoutsByProduct = {
  "pvc-walls": [
    { id: "straight", name: "Straight Wall", desc: "Single run partition" },
    { id: "l-shape", name: "L-Shape", desc: "Two walls at 90 degrees" },
    { id: "u-shape", name: "U-Shape", desc: "Three-sided enclosure" },
    { id: "full-enclosure", name: "Full Enclosure", desc: "Four-sided room" },
    { id: "multiple-runs", name: "Multiple Runs", desc: "Parallel partition walls" },
  ],
  "sliding-curtains": [
    { id: "straight", name: "Straight Run", desc: "Single curtain track" },
    { id: "l-shape", name: "L-Shape", desc: "Two-sided curtain track" },
    { id: "u-shape", name: "U-Shape", desc: "Three-sided curtain track" },
    { id: "full-enclosure", name: "Full Enclosure", desc: "Four-sided curtain system" },
    { id: "multiple-runs", name: "Multiple Runs", desc: "Multiple curtain tracks" },
  ],
  "industrial-covers": [
    { id: "flat", name: "Flat Cover", desc: "Flat protective cover" },
    { id: "peaked", name: "Peaked Cover", desc: "Peaked / ridged cover" },
    { id: "custom-shape", name: "Custom Shape", desc: "Bespoke shape to spec" },
  ],
  "welding-screens": [
    { id: "single-panel", name: "Single Panel", desc: "One fixed screen" },
    { id: "multi-panel", name: "Multi-Panel", desc: "Multiple connected panels" },
    { id: "portable", name: "Portable", desc: "Moveable screen on wheels" },
  ],
  "weather-protection": [
    { id: "single-opening", name: "Single Opening", desc: "Cover one open side" },
    { id: "double-opening", name: "Double Opening", desc: "Cover two open sides" },
    { id: "full-perimeter", name: "Full Perimeter", desc: "Enclose the full perimeter" },
  ],
  custom: [
    { id: "custom", name: "Custom Design", desc: "Describe in notes at the end" },
  ],
};

// SVG diagrams for common layouts
function LayoutDiagram({ layoutId }) {
  const s = { stroke: "#FF5722", strokeWidth: 3, fill: "none" };
  const sDim = { stroke: "#555", strokeWidth: 1, strokeDasharray: "4 2" };
  const w = 120, h = 80;

  const diagrams = {
    straight: (
      <svg viewBox="0 0 120 80" className="w-full h-full">
        <line x1="20" y1="15" x2="20" y2="65" {...s} />
        <line x1="20" y1="15" x2="30" y2="15" {...sDim} />
        <line x1="20" y1="65" x2="30" y2="65" {...sDim} />
        <text x="35" y="43" fill="#A3A3A3" fontSize="8">H</text>
        <rect x="40" y="20" width="60" height="40" fill="#1F1F1F" stroke="#2E2E2E" strokeWidth="1" rx="2" />
        <text x="60" y="44" fill="#666" fontSize="7" textAnchor="middle">AREA</text>
      </svg>
    ),
    "l-shape": (
      <svg viewBox="0 0 120 80" className="w-full h-full">
        <polyline points="20,15 20,65 80,65" {...s} />
        <rect x="30" y="20" width="50" height="35" fill="#1F1F1F" stroke="#2E2E2E" strokeWidth="1" rx="2" />
        <text x="50" y="42" fill="#666" fontSize="7" textAnchor="middle">AREA</text>
        <text x="10" y="43" fill="#A3A3A3" fontSize="7">A</text>
        <text x="48" y="75" fill="#A3A3A3" fontSize="7">B</text>
      </svg>
    ),
    "u-shape": (
      <svg viewBox="0 0 120 80" className="w-full h-full">
        <polyline points="80,15 20,15 20,65 80,65" {...s} />
        <rect x="30" y="25" width="50" height="30" fill="#1F1F1F" stroke="#2E2E2E" strokeWidth="1" rx="2" />
        <text x="50" y="44" fill="#666" fontSize="7" textAnchor="middle">AREA</text>
      </svg>
    ),
    "full-enclosure": (
      <svg viewBox="0 0 120 80" className="w-full h-full">
        <rect x="20" y="15" width="60" height="50" {...s} />
        <text x="50" y="44" fill="#666" fontSize="7" textAnchor="middle">ENCLOSED</text>
      </svg>
    ),
    "multiple-runs": (
      <svg viewBox="0 0 120 80" className="w-full h-full">
        <line x1="25" y1="15" x2="25" y2="65" {...s} />
        <line x1="50" y1="15" x2="50" y2="65" {...s} />
        <line x1="75" y1="15" x2="75" y2="65" {...s} />
        <rect x="30" y="25" width="15" height="30" fill="#1F1F1F" stroke="#2E2E2E" strokeWidth="1" rx="1" />
        <rect x="55" y="25" width="15" height="30" fill="#1F1F1F" stroke="#2E2E2E" strokeWidth="1" rx="1" />
      </svg>
    ),
    flat: (
      <svg viewBox="0 0 120 80" className="w-full h-full">
        <rect x="20" y="30" width="80" height="6" fill="#FF5722" opacity="0.6" />
        <rect x="20" y="40" width="80" height="25" fill="#1F1F1F" stroke="#2E2E2E" strokeWidth="1" rx="2" />
        <text x="60" y="56" fill="#666" fontSize="7" textAnchor="middle">OBJECT</text>
      </svg>
    ),
    peaked: (
      <svg viewBox="0 0 120 80" className="w-full h-full">
        <polyline points="20,40 60,20 100,40" {...s} />
        <line x1="20" y1="40" x2="20" y2="60" stroke="#FF5722" strokeWidth="2" />
        <line x1="100" y1="40" x2="100" y2="60" stroke="#FF5722" strokeWidth="2" />
        <rect x="25" y="45" width="70" height="20" fill="#1F1F1F" stroke="#2E2E2E" strokeWidth="1" rx="2" />
        <text x="60" y="58" fill="#666" fontSize="7" textAnchor="middle">OBJECT</text>
      </svg>
    ),
    "single-panel": (
      <svg viewBox="0 0 120 80" className="w-full h-full">
        <rect x="35" y="15" width="50" height="50" {...s} rx="1" />
        <text x="60" y="44" fill="#666" fontSize="7" textAnchor="middle">SCREEN</text>
      </svg>
    ),
    "multi-panel": (
      <svg viewBox="0 0 120 80" className="w-full h-full">
        <rect x="10" y="15" width="30" height="50" {...s} rx="1" />
        <rect x="45" y="15" width="30" height="50" {...s} rx="1" />
        <rect x="80" y="15" width="30" height="50" {...s} rx="1" />
      </svg>
    ),
    portable: (
      <svg viewBox="0 0 120 80" className="w-full h-full">
        <rect x="35" y="10" width="50" height="48" {...s} rx="1" />
        <circle cx="45" cy="65" r="5" stroke="#FF5722" strokeWidth="2" fill="none" />
        <circle cx="75" cy="65" r="5" stroke="#FF5722" strokeWidth="2" fill="none" />
      </svg>
    ),
    "single-opening": (
      <svg viewBox="0 0 120 80" className="w-full h-full">
        <line x1="60" y1="15" x2="60" y2="65" {...s} />
        <rect x="65" y="20" width="40" height="40" fill="#1F1F1F" stroke="#2E2E2E" strokeWidth="1" rx="2" />
        <text x="85" y="44" fill="#666" fontSize="7" textAnchor="middle">BLDG</text>
      </svg>
    ),
    "double-opening": (
      <svg viewBox="0 0 120 80" className="w-full h-full">
        <line x1="30" y1="15" x2="30" y2="65" {...s} />
        <line x1="90" y1="15" x2="90" y2="65" {...s} />
        <rect x="40" y="20" width="40" height="40" fill="#1F1F1F" stroke="#2E2E2E" strokeWidth="1" rx="2" />
        <text x="60" y="44" fill="#666" fontSize="7" textAnchor="middle">BLDG</text>
      </svg>
    ),
    "full-perimeter": (
      <svg viewBox="0 0 120 80" className="w-full h-full">
        <rect x="20" y="15" width="80" height="50" {...s} />
        <text x="60" y="44" fill="#666" fontSize="7" textAnchor="middle">BLDG</text>
      </svg>
    ),
    "custom-shape": (
      <svg viewBox="0 0 120 80" className="w-full h-full">
        <polygon points="30,60 20,30 50,15 90,20 100,50 70,65" {...s} />
        <text x="58" y="44" fill="#666" fontSize="7" textAnchor="middle">CUSTOM</text>
      </svg>
    ),
    custom: (
      <svg viewBox="0 0 120 80" className="w-full h-full">
        <polygon points="30,60 20,30 50,15 90,20 100,50 70,65" {...s} />
        <text x="58" y="44" fill="#666" fontSize="7" textAnchor="middle">CUSTOM</text>
      </svg>
    ),
  };

  return diagrams[layoutId] || diagrams.straight;
}

export default function StepLayout({ form, setForm }) {
  const layouts = layoutsByProduct[form.product_type] || layoutsByProduct.custom;

  return (
    <div>
      <h2
        className="text-2xl sm:text-3xl font-bold tracking-tight mb-2"
        style={{ fontFamily: "'Clash Display', sans-serif" }}
      >
        Choose a Layout
      </h2>
      <p className="text-sm text-[#A3A3A3] mb-8">Select the configuration that best matches your project.</p>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
        {layouts.map((l) => {
          const selected = form.layout === l.id;
          return (
            <button
              key={l.id}
              type="button"
              data-testid={`layout-select-${l.id}`}
              onClick={() => setForm((prev) => ({ ...prev, layout: l.id }))}
              className={`text-center p-4 border transition-all duration-200 ${
                selected
                  ? "border-[#FF5722] bg-[#FF5722]/5"
                  : "border-[#2E2E2E] bg-[#141414] hover:border-[#FF5722]/50"
              }`}
            >
              <div className="w-full aspect-[3/2] mb-3">
                <LayoutDiagram layoutId={l.id} />
              </div>
              <p className={`font-bold text-xs ${selected ? "text-[#FF5722]" : "text-white"}`} style={{ fontFamily: "'Clash Display', sans-serif" }}>
                {l.name}
              </p>
              <p className="text-[10px] text-[#A3A3A3] mt-1">{l.desc}</p>
            </button>
          );
        })}
      </div>
    </div>
  );
}
